// User state management
export class UserState {
    constructor() {
        this.currentUser = null;
        this.listeners = new Set();
    }
    getCurrentUser() {
        return this.currentUser;
    }
    isLoggedIn() {
        return this.currentUser !== null;
    }
    setUser(user) {
        const previousUser = this.currentUser;
        this.currentUser = user;
        console.log('[user-state] User state changed:', {
            previous: previousUser?.email,
            current: user?.email
        });
        // Notify all listeners
        this.listeners.forEach(listener => {
            try {
                listener(user);
            }
            catch (error) {
                console.error('[user-state] Error in listener:', error);
            }
        });
    }
    onUserChange(listener) {
        this.listeners.add(listener);
        // Return unsubscribe function
        return () => {
            this.listeners.delete(listener);
        };
    }
    clearUser() {
        this.setUser(null);
    }
}
// Singleton instance
export const userState = new UserState();
